import script from "./UserSubscribers.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSubscribers.vue?vue&type=script&setup=true&lang=ts"

import "./UserSubscribers.vue?vue&type=style&index=0&id=2fc185b2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc185b2"]])

export default __exports__